import "./DashboardHelpCentreComponent.scss";
import {IComponentOptions, IOnInit, IRootElementService} from "angular";

export const HelpCentre = "tfDashboardHelpCentre";

export function helpCentre(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/help-centre/DashboardHelpCentreComponent.html`,
        controllerAs: "ctrl",
        controller: DashboardHelpCentreComponentController
    };
}

export class DashboardHelpCentreComponentController implements IOnInit {

    /** @ngInject */
    public constructor(private $element: IRootElementService) {

    }

    public $onInit(): void {
        this.$element.addClass("summary-box");
    }
}
